import menu from './menuItems';

const FT_MENU = [
    {
        ...menu[1].icedTea[0]
    },
    {
        ...menu[3].slush[0]
    },
    {
        ...menu[0].milkTea[1]
    }
]

export default FT_MENU;